export class Tabs {
  constructor(cls) {
    this._elem = document.querySelector(cls);
    if (this._elem === null) {
      return;
    }
    this._init();
    this._arrays = [this._titles, this._containers];
    this._prevIndex = null;
    this._currentIndex = 0;

    this._setActiveClass();
  }

  _init() {
    this._titles = this._elem.querySelectorAll('.tabs__title');
    this._containers = this._elem.querySelectorAll('.tabs__container');

    this._tabClickHanler = this._tabClickHanler.bind(this);

    this._setHandlers();
  }

  show(num) {
    if (this._currentIndex !== num) {
      this._prevIndex = this._currentIndex;
      this._currentIndex = num;
      this._show();
    }
  }

  getWrapper() {
    return this._elem.querySelector('.tabs-wrapper');
  }

  getActiveTab() {
    return this._currentIndex;
  }

  getActiveTitle() {
    return this._titles[this._currentIndex];
  }

  getActiveContainer() {
    return this._containers[this._currentIndex];
  }

  tabClickHandler() {}

  _show() {
    this._hide();
    this._titles[this._currentIndex].classList.add('active');
    this._containers[this._currentIndex].classList.add('active');
  }

  _hide() {
    this._titles[this._prevIndex].classList.remove('active');
    this._containers[this._prevIndex].classList.remove('active');
  }

  _setHandlers() {
    this._elem.addEventListener('click', this._tabClickHanler);
  }

  _setActiveClass() {
    this._titles[this._currentIndex].classList.add('active');
    this._containers[this._currentIndex].classList.add('active');
  }

  _tabClickHanler(evt) {
    if (this._isNav(evt) && !this._isActive(evt)) {
      let title = evt.target.closest('.tabs__title');
      this._prevIndex = this._currentIndex;
      this._currentIndex = Array.from(this._titles).indexOf(title);
      this._show();
      this.tabClickHandler();
    }
  }

  _isNav(evt) {
    return evt.target.closest('.tabs__title');
  }

  _isActive(evt) {
    return evt.target.closest('.tabs__title').classList.contains('active');
  }

}
